import Mixin from "./mixin";
import Logger from "./logger";
import Listener from "./listener";
import Emitter from "./emitter";

import streamApi from "@/api/streamApi";

export default class StreamCore {
  /**
   * lets take all resource
   * @param vuex
   * @param debug
   */
  constructor({ vuex, debug }) {
    Logger.debug = debug;

    this.streamApi = this.connect();
    this.emitter = new Emitter(vuex);

    this.listener = new Listener(this.streamApi, this.emitter, vuex);
  }

  /**
   * Vue.js entry point
   * @param Vue
   */
  install(Vue) {
    Vue.prototype.$streamApi = this.streamApi;
    Vue.prototype.$streamCore = this;
    Vue.mixin(Mixin);

    Logger.info("StreamCore plugin enabled");
  }

  /**
   * registering stream instance
   */
  connect() {
    return (this.streamApi = streamApi);
  }
}
